import React from 'react';
import { WebhookSubscriptionEventItem } from 'types';
import {
  RadioButton20,
  CheckmarkOutline20,
  NotificationOff16
} from '@carbon/icons-react';
import { SkeletonText } from 'carbon-components-react';

const EventPanel: React.FC<Props> = ({
  isLoading,
  helpText,
  title,
  events,
  onEventClick
}) => {
  const renderIcon = (status: string) => {
    switch (status) {
      case 'subscribed': {
        return <CheckmarkOutline20 />;
      }
      case 'paused': {
        return <NotificationOff16 />;
      }
      default: {
        return <RadioButton20 />;
      }
    }
  };
  return (
    <div className="webhook-subscriptions-event-panel-container">
      <div className="webhook-subscriptions-event-panel-content">
        <div className="title">{title}</div>
        <div className="webhook-subscriptions-event-list-container">
          {events.map((event: WebhookSubscriptionEventItem, inx: number) => {
            return isLoading ? (
              <SkeletonText key={inx} />
            ) : (
              <div
                key={inx}
                className="webhook-subscriptions-event"
                onClick={() => onEventClick(event)}
              >
                <div className={`event-icon ${event.status}`}>
                  {renderIcon(event.status)}
                </div>
                <div className="event-label">{event.label}</div>
              </div>
            );
          })}
        </div>
      </div>
      <div className="webhook-subscriptions-event-panel-help-text">
        {helpText}
      </div>
    </div>
  );
};

type Props = {
  isLoading: boolean;
  helpText: string;
  title: string;
  events: WebhookSubscriptionEventItem[];
  onEventClick: Function;
};

export default React.memo(EventPanel);
